<div class="d-flex flex-column justify-content-center wrapper" *ngIf="isWallet === false && truScaleSidebarData">
  <div class="offcanvas-body d-flex flex-column">
    <h4 class="mb-0 text-uppercase title">{{ 'Summary' | translate }}</h4>
  </div>
  <hr />
  <div class="offcanvas-body d-flex flex-column">
    <div class="mt-2 d-flex justify-content-between">
      <h6>{{ 'Truscale dass revenue total' | translate }}</h6>
      <div>{{ truScaleSidebarData.currencySymbol }}{{ truScaleSidebarData.servicesRevenueTotal | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between">
      <h6>{{ 'Leap points total' | translate }}</h6>
      <div>{{ truScaleSidebarData.leapPointsTotal | number }}</div>
    </div>
  </div>
  <div class="mb-3 offcanvas-body d-flex flex-column">
    <div class="mt-2 d-flex justify-content-between">
      <h6>{{ 'Revenue required for your next 100 leap points' | translate }}</h6>
      <div>{{ truScaleSidebarData.currencySymbol }}{{ truScaleSidebarData.revenueForNextAward | number }}</div>
    </div>
  </div>
</div>
